import {PageEvent} from '@spartacus/storefront';

export class CategoryPageEvent extends PageEvent {}
